// eslint-disable-next-line import/prefer-default-export
export enum ConnectionStatus {
  ACTIVE = 'active',
  WARNING = 'warning',
  ERROR = 'error',
  PAUSED = 'paused',
  ALERT = 'alert',
}
